import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';
import {  handleReportsToken} from '../../../constant/utils';
import { config } from '../../../constant';

const WebPushConfig = () => {

    const iframeRef = useRef<HTMLIFrameElement>(null);
    const env = import.meta.env.VITE_APP_ENV;
    const location = useLocation();
    const navigate = useNavigate();
   
    console.log('location?.state', location?.state)
    const encryptedToken = handleReportsToken();
    const sourceUrl: string = `${config().CAMPAIGN_URL}/cvmwebpushconfig?cvm_data=${encryptedToken}`;
    // const sourceUrl: string = `https://2a20ab9f5cb6.ngrok-free.app/cvmwebpushconfig?cvm_data=${encryptedToken}`;
    console.log('sourceUrl>>>>',sourceUrl)
    return (

            <iframe
                id="smsCampaignFrame"
                ref={iframeRef}
                src={sourceUrl}
                style={{ width: "100%", height: "100%", border: 'none' }}
            />

        
    )
}

export default WebPushConfig
